module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminnoticias-crear/adminnoticias-crear.component.scss
// module id = ./src/app/adminnoticias-crear/adminnoticias-crear.component.scss
// module chunks = main